module.exports = __webpack_public_path__ + "icon-alertminer-contract.595d23a2cefbad8ca872.png";